// extracted by mini-css-extract-plugin
module.exports = {"SpinnerDefault":"spinner_SpinnerDefault__VWpx8","SpinnerLarge":"spinner_SpinnerLarge__Fitgu","SpinnerSeasonal":"spinner_SpinnerSeasonal__wSnmu"};